import { Entity, stringifyEntityRef } from '@backstage/catalog-model';
import { useApi } from '@backstage/core-plugin-api';
import { catalogApiRef, useEntity } from '@backstage/plugin-catalog-react';
import { useState, useEffect } from 'react';

export function useOwnedResources(): {
    entities: Entity[] | undefined;
    loading: boolean;
} {
    const { entity } = useEntity();
    const catalogApi = useApi(catalogApiRef);
    const [loading, setLoading] = useState(true);
    const [entities, setEntities] = useState<Entity[] | undefined>(undefined);

    useEffect(() => {
        const productRefs: string[] = (entity.spec as any)?.products?.map(
            (it: any) =>
                stringifyEntityRef({
                    kind: 'Product',
                    name: it as string,
                }),
        );
        catalogApi
            .getEntitiesByRefs({
                entityRefs: productRefs,
            })
            .then(response => {
                const filter = response.items
                    .filter(it => !!it)
                    .map(it => {
                        return {
                            kind: ['Resource', 'Product'],
                            'spec.owner': it?.spec?.owner as string,
                        };
                    });
                catalogApi
                    .getEntities({
                        filter: filter,
                    })
                    .then(response => {
                        setEntities(response.items);
                        setLoading(false);
                    });
            });
    }, [catalogApi]);

    return { loading: loading, entities: entities };
}
